import { getUserPreferences } from "./userPreferences";

export function getCampaignBuilderDefaults(userId) {
    const prefs = getUserPreferences(userId);

    return {
        basicDetails: {
            name: "",
            platform: prefs.platform,
            language: prefs.language,
        },
        followUp: {
            tone: "",
            topic: "",
            target: prefs.target || "",
            hashtags: [],
            opportunities: [],
        },
    };
}
